import './Menu.css';
import * as MENU_IMAGES from '../../../images/Menu/Menu.js';
import { BsGlobe, BsInstagram } from 'react-icons/bs';

const Menu = () => {
  return (
    <div className="template-container menu-page">
      <div className="menu-images-container">
        {Object.values(MENU_IMAGES).map((img, idx) => (
          <img key={idx} src={img} alt={`Menú ${idx + 1}`} className="menu-image" />
        ))}
      </div>
      <div className="menu-fixed-icons responsive-icons">
          <a href='https://instagram.com/panditoicecream' target='_blank' rel='noreferrer'>
            <BsInstagram className="footer-icon" />
          </a>
          <a href='https://pandito.ch' target='_blank' rel='noreferrer'>
            <BsGlobe className="footer-icon" />
          </a>
      </div>
    </div>
  );
};

export default Menu;
